import React, { useState, useEffect } from "react";

interface MonthSelectorProps {
  selectedYear: number;
  selectedMonth: number;
  onLoadReport: (year: number, month: number) => void;
}

const MONTHS_SHORT = [
  "Jan", "Feb", "Mar", "Apr", "May", "Jun",
  "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
];

export const MonthSelector: React.FC<MonthSelectorProps> = ({
  selectedYear,
  selectedMonth,
  onLoadReport,
}) => {
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 3 }, (_, i) => currentYear - i);

  const [bufferedYear, setBufferedYear] = useState(selectedYear);
  const [bufferedMonth, setBufferedMonth] = useState(selectedMonth);

  useEffect(() => {
    setBufferedYear(selectedYear);
    setBufferedMonth(selectedMonth);
  }, [selectedYear, selectedMonth]);

  const hasChanged = bufferedYear !== selectedYear || bufferedMonth !== selectedMonth;

  return (
    <div className="flex items-center gap-1.5">
      <select
        value={bufferedMonth}
        onChange={(e) => setBufferedMonth(parseInt(e.target.value))}
        className="px-2 py-1.5 text-sm border border-gray-200 rounded-md bg-white focus:outline-hidden focus:ring-1 focus:ring-blue-500"
      >
        {MONTHS_SHORT.map((month, index) => (
          <option key={index} value={index + 1}>{month}</option>
        ))}
      </select>
      <select
        value={bufferedYear}
        onChange={(e) => setBufferedYear(parseInt(e.target.value))}
        className="px-2 py-1.5 text-sm border border-gray-200 rounded-md bg-white focus:outline-hidden focus:ring-1 focus:ring-blue-500"
      >
        {years.map((year) => (
          <option key={year} value={year}>{year}</option>
        ))}
      </select>
      {hasChanged && (
        <button
          onClick={() => onLoadReport(bufferedYear, bufferedMonth)}
          className="px-2.5 py-1.5 text-xs font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 transition-colors"
        >
          Go
        </button>
      )}
    </div>
  );
};
